/**
 * Block component registry. Maps block_type → React component.
 *
 * Every block_type referenced from seed.json + blockTypes.md is registered
 * below. The BlockRenderer falls back to StubBlock if a key is missing.
 */
import HeroCarousel from './types/HeroCarousel';
import AnnouncementMarquee from './types/AnnouncementMarquee';
import AboutCollage from './types/AboutCollage';
import BatchesTiming from './types/BatchesTiming';
import ProgrammeTabs from './types/ProgrammeTabs';
import PillarsAlternating from './types/PillarsAlternating';
import LeadershipTabs from './types/LeadershipTabs';
import InfrastructureGrid from './types/InfrastructureGrid';
import StatsCounter from './types/StatsCounter';
import BoardResults from './types/BoardResults';
import VisionMission from './types/VisionMission';
import TestimonialCarousel from './types/TestimonialCarousel';
import ActivityGallery from './types/ActivityGallery';
import FaqAccordion from './types/FaqAccordion';
import AdmissionsSteps from './types/AdmissionsSteps';
import AlumniPlaceholder from './types/AlumniPlaceholder';
import ContactLocate from './types/ContactLocate';

import PageHeroBlock from './types/PageHeroBlock';
import ImageTextList from './types/ImageTextList';
import DirectorWelcome from './types/DirectorWelcome';
import EthosPillars from './types/EthosPillars';
import LeadershipCards from './types/LeadershipCards';
import SignaturePrograms from './types/SignaturePrograms';

import CurriculumHighlights from './types/CurriculumHighlights';
import ProgramLevels from './types/ProgramLevels';
import ImageTextTwoCol from './types/ImageTextTwoCol';
import SecondaryFeature from './types/SecondaryFeature';
import FacultyDepartments from './types/FacultyDepartments';
import SanchetnaProgram from './types/SanchetnaProgram';
import LibraryFeature from './types/LibraryFeature';

import AdmissionCriteria from './types/AdmissionCriteria';
import DocumentsPair from './types/DocumentsPair';
import ProspectusDeadlines from './types/ProspectusDeadlines';
import RegistrationForm from './types/RegistrationForm';
import ContactAdmissions from './types/ContactAdmissions';

import AlumniStories from './types/AlumniStories';
import PtaGallery from './types/PtaGallery';
import EventsCalendar from './types/EventsCalendar';
import OutreachPillars from './types/OutreachPillars';

import PrincipalMessage from './types/PrincipalMessage';
import ProspectusDownload from './types/ProspectusDownload';

import LifePillars from './types/LifePillars';
import ClubsGrid from './types/ClubsGrid';
import StudentVoiceHouse from './types/StudentVoiceHouse';
import MomentsGallery from './types/MomentsGallery';

import SportsPrograms from './types/SportsPrograms';
import FacilitiesStats from './types/FacilitiesStats';
import CalendarTable from './types/CalendarTable';

import FeaturesList from './types/FeaturesList';
import LoginForm from './types/LoginForm';

import NavbarBlock from './types/NavbarBlock';
import FooterBlock from './types/FooterBlock';

import StubBlock from './types/StubBlock';

const registry = {
  // Home
  'hero-carousel': HeroCarousel,
  'announcement-marquee': AnnouncementMarquee,
  'about-collage': AboutCollage,
  'batches-timing': BatchesTiming,
  'programme-tabs': ProgrammeTabs,
  'pillars-alternating': PillarsAlternating,
  'leadership-tabs': LeadershipTabs,
  'infrastructure-grid': InfrastructureGrid,
  'stats-counter': StatsCounter,
  'board-results': BoardResults,
  'vision-mission': VisionMission,
  'testimonial-carousel': TestimonialCarousel,
  'activity-gallery': ActivityGallery,
  'faq-accordion': FaqAccordion,
  'admissions-steps': AdmissionsSteps,
  'alumni-placeholder': AlumniPlaceholder,
  'contact-locate': ContactLocate,

  // Shared / About
  'page-hero': PageHeroBlock,
  'image-text-list': ImageTextList,
  'director-welcome': DirectorWelcome,
  'ethos-pillars': EthosPillars,
  'leadership-cards': LeadershipCards,
  'signature-programs': SignaturePrograms,

  // Academics
  'curriculum-highlights': CurriculumHighlights,
  'program-levels': ProgramLevels,
  'image-text-two-col': ImageTextTwoCol,
  'secondary-feature': SecondaryFeature,
  'faculty-departments': FacultyDepartments,
  'sanchetna-program': SanchetnaProgram,
  'library-feature': LibraryFeature,

  // Admissions
  'admission-criteria': AdmissionCriteria,
  'documents-pair': DocumentsPair,
  'prospectus-deadlines': ProspectusDeadlines,
  'registration-form': RegistrationForm,
  'contact-admissions': ContactAdmissions,

  // Community
  'alumni-stories': AlumniStories,
  'pta-gallery': PtaGallery,
  'events-calendar': EventsCalendar,
  'outreach-pillars': OutreachPillars,

  // Principal / Prospectus
  'principal-message': PrincipalMessage,
  'prospectus-download': ProspectusDownload,

  // Scottian Life
  'life-pillars': LifePillars,
  'clubs-grid': ClubsGrid,
  'student-voice-house': StudentVoiceHouse,
  'moments-gallery': MomentsGallery,

  // Sports
  'sports-programs': SportsPrograms,
  'facilities-stats': FacilitiesStats,
  'calendar-table': CalendarTable,

  // Parent Login
  'features-list': FeaturesList,
  'login-form': LoginForm,

  // Globals
  navbar: NavbarBlock,
  footer: FooterBlock,
};

export function getBlockComponent(type) {
  return registry[type] || StubBlock;
}

export default registry;
